import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../../../Payroll/helper-payroll/constants/payrollConstants";

export const _getCasesType = (obj) => {
  return {
    firstCase:
      obj.payrollType === "Basic Pay" && obj.payItem === "General Payroll",

    secondCase:
      obj.payrollType === "Basic Pay" &&
      obj.jobType !== "Job Order" &&
      obj.payItem === "Addendum Payroll",

    thirdCase:
      obj.payrollType === "Basic Pay" && isAddendumBackPayItem(obj.payItem),
    fourthCase:
      obj.payrollType === "Basic Pay" &&
      obj.jobType === "Job Order" &&
      (obj.payItem === "Salary" || isBackPayItem(obj.payItem)),
    sixthCase:
      obj.payrollType === "Augmentation Pay" &&
      (obj.payItem === "General Payroll" ||
        obj.payItem === "Newly-Hired" ||
        isBackPayItem(obj.payItem)),
    seventhCase:
      obj.payrollType === "Individual Payroll" &&
      obj.jobType !== "Job Order" &&
      (obj.payItem === "Initial Salary" || obj.payItem === "Last Salary"),
    eightCase:
      obj.payrollType === "Individual Payroll" &&
      (obj.payItem === "Initial Salary(AP)" ||
        obj.payItem === "Last Salary(AP)"),
    ninthCase:
      obj.payrollType === "Individual Payroll" &&
      obj.payItem === "Initial RATA",
    tenthCase:
      obj.payrollType === "Individual Payroll" &&
      obj.payItem === "Salary Differential (Basic)",
    eleventhCase:
      obj.payrollType === "Individual Payroll" &&
      obj.jobType === "Job Order" &&
      (obj.payItem === "Initial Salary" || obj.payItem === "Last Salary"),
    twelveCase:
      obj.payrollType === "Special Payroll" &&
      obj.payItem === "20% Monthly Premium",
    thirteenthCase:
      obj.payrollType === "Special Payroll" &&
      obj.payItem !== "20% Monthly Premium",
  };
};

export const caseRegistry = {
  isBasicGeneral: ({ payrollType = "", payItem = "" }) =>
    payrollType === "Basic Pay" && payItem === "General Payroll",

  isBasicAddendum: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Basic Pay" &&
    jobType !== "Job Order" &&
    payItem === "Addendum Payroll",

  isBasicBackpay: ({ payrollType, payItem }) =>
    payrollType === "Basic Pay" && isAddendumBackPayItem(payItem),

  isApGeneralNewly: ({ payrollType = "", payItem = "" }) =>
    payrollType === "Augmentation Pay" &&
    (payItem === "General Payroll" || payItem === "Newly-Hired"),

  isBasicJoSalary: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Basic Pay" &&
    jobType === "Job Order" &&
    payItem === "Salary",

  isBasicJoAddendum: ({ payrollType, jobType, payItem }) =>
    payrollType === "Basic Pay" &&
    jobType === "Job Order" &&
    isBackPayItem(payItem),

  isInitialLastIp: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Individual Payroll" &&
    jobType !== "Job Order" &&
    (payItem === "Initial Salary" || payItem === "Last Salary"),
  isIndividualAPBackpay: ({ payrollType = "", payItem = "" }) =>
    payrollType === "Individual Payroll" &&
    (payItem === "Initial Salary(AP)" || payItem === "Last Salary(AP)"),
  isNinthCase: ({ payrollTypes = "", payItems = "" }) =>
    payrollTypes === "IP" && payItems === "Rata",
  isIndividualDiff: ({ payrollType = "", payItem = "" }) =>
    payrollType === "Individual Payroll" &&
    payItem === "Salary Differential (Basic)",
  isIndividualJoBackpay: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Individual Payroll" &&
    jobType === "Job Order" &&
    payItem === "Last Salary",
  isIndividualJoInitial: ({ payrollType = "", jobType = "", payItem = "" }) =>
    payrollType === "Individual Payroll" &&
    jobType === "Job Order" &&
    payItem === "Initial Salary",
  isApBackpay: ({ payrollType, payItem }) =>
    payrollType === "Augmentation Pay" && isBackPayItem(payItem),
  isTirteenthCase: ({ payrollTypes = "", payItems = "" }) =>
    payrollTypes === "SP",
};

export const caseFieldMap = {
  firstCase: ["acctNo", "accountNumber", "employeeNumber"],
  secondCase: ["acctNo", "accountNumber", "employeeNumber", "gsisInsuredDays"],
  thirdCase: [
    "acctNo",
    "accountNumber",
    "daysInAMonth",
    "gsisInsuredDays",
    "employeeNumber",
  ],
  fourthCase: [
    "acctNo",
    "accountNumber",
    "employeeNumber",
    "year",
    "minsToBeDeducted",
    "noOfDays",
  ],
  sixthCase: [
    "acctNo",
    "accountNumber",
    "abs",
    "abs2",
    "year",
    "OfDutyForCiaMciaBinocRangeTo1519",
    "latesUtPerMinute",
    "noOfDuties",
    "employeeNumber",
    "totalDaysDuty",
  ],
  seventhCase: [
    "acctNo",
    "accountNumber",
    "employeeNumber",
    "peraAda",
    "gross",
    "inService",
    "proratedRate",
    "proratedPera",
  ],
  eightCase: ["acctNo", "accountNumber", "employeeNumber"],
  ninthCase: ["acctNo", "accountNumber", "employeeNumber"],
  tenthCase: ["acctNo", "accountNumber", "employeeNumber"],
  eleventhCase: [
    "acctNo",
    "accountNumber",
    "employeeNumber",
    "noOfDaysPresent",
    "absDays",
    "absMins",
    "perDay",
    "perMinute",
  ],
  twelveCase: ["acctNo", "accountNumber", "employeeNumber"],
  thirteenthCase: ["acctNo", "accountNumber", "employeeNumber"],
};
